import { apiFetch } from './client';
import type {
  NebulaConversationDetail,
  NebulaConversationListData,
  NebulaConversationListParams,
  NebulaDaysFilter,
  NebulaOverviewData,
} from '../../types/nebula-insights';

function buildDaysQuery(days: NebulaDaysFilter = 'recent'): string {
  if (days === 'all') return 'all';
  if (days === 'recent') return 'recent';
  return String(days);
}

export async function fetchNebulaOverview(
  days: NebulaDaysFilter = 'recent'
): Promise<NebulaOverviewData> {
  const response = await apiFetch(
    `/admin/nebula-insights/overview?days=${buildDaysQuery(days)}`
  );
  return response.data;
}

export async function fetchNebulaConversations(
  params: NebulaConversationListParams = {}
): Promise<NebulaConversationListData> {
  const searchParams = new URLSearchParams();
  searchParams.set('page', String(params.page ?? 1));
  searchParams.set('limit', String(params.limit ?? 20));
  searchParams.set('days', buildDaysQuery(params.days ?? 'recent'));

  if (params.search?.trim()) {
    searchParams.set('search', params.search.trim());
  }
  if (params.artistId?.trim()) {
    searchParams.set('artistId', params.artistId.trim());
  }
  if (params.model?.trim()) {
    searchParams.set('model', params.model.trim());
  }

  const response = await apiFetch(
    `/admin/nebula-insights/conversations?${searchParams.toString()}`
  );
  return response.data;
}

export async function fetchNebulaConversationDetail(
  conversationId: string
): Promise<NebulaConversationDetail> {
  const response = await apiFetch(
    `/admin/nebula-insights/conversations/${encodeURIComponent(conversationId)}`
  );
  return response.data;
}
